'use strict'
var users = angular.module('usersModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap',
	'ui.tinymce'
]);
require('./allusers/js/directive/allusersDirective.js')(users);
require('./allusers/js/allusersController.js')(users);

require('./allusers/js/directive/userEditDirective.js')(users);
require('./newuser/js/directive/userDirective.js')(users);
require('./newuser/js/userController.js')(users);
require('./profile/js/directive/profileDirective.js')(users);
require('./profile/js/userProfileController.js')(users)



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/usersModule/usersModule.js
// module id = 639
// module chunks = 0